import { render } from "./AddImpiantiPage.vue?vue&type=template&id=8a0f3378"
import script from "./AddImpiantiPage.vue?vue&type=script&lang=js"
export * from "./AddImpiantiPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__